import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  NG_VALUE_ACCESSOR,
  ControlValueAccessor, ReactiveFormsModule,
} from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
  selector: 'app-mb-text-area',
  imports: [CommonModule, NzInputModule, FormsModule, NzIconModule, ReactiveFormsModule, TranslocoDirective],
  standalone: true,
  templateUrl: './mb-text-area.component.html',
  styleUrls: ['./mb-text-area.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MbTextAreaComponent),
      multi: true,
    },
  ],
})
export class MbTextAreaComponent implements ControlValueAccessor {
  @Input() placeholder = '';
  @Input() prefixLabel = '';
  @Input() type = 'text';
  @Input() icon = '';
  @Input() containerClass = '';
  @Input() errorMessage = ''; // New input for error message
  @Input() hasError = false; // New input to indicate error state

  value = '';
  disabled = false;
  showPassword = false;

  // ControlValueAccessor methods
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onChange: (_value: string) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onTouched = () => {};

  get containerClasses(): string {
    return `${this.containerClass}`;
  }


  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
